import React from "react"
import {findDOMNode} from "react-dom"
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import FieldSelectTask from "../../select-task";
import FieldSelectTask_Popover_Selector from "./task";
import Task from "../../../../../model2/task/task";
import FieldPopover_FormComponent from "../../../../generic/popover/components/form/form-component";


// const debug = "FieldSelectTask_Popover"
const debug = false

type Props = {
    parent: FieldPopover_FormComponent
    field: FieldSelectTask
    model: any
}

export default function FieldSelectTask_Popover(props: Props) {

    debug && console.log(debug, 'render', props)

    const onClickOutside = (e:any) => {
        // if (refNewView.current?.isPopoverShown) return
        // if (gd.utils.Dom.findNodeByClassName(e.target, ["top-project-views-popover", "popover-project-view"])) return

        props.parent.hidePopover()
    }
    const onClickTask = (data: Task) => {

        debug && console.log(debug, "onClickTask data=", data)

        props.parent.hidePopover()
        props.parent.onValueChange(data, true)
    }


    const field: FieldSelectTask   = props.field
    const value: any               = field.getViewValue(props.model)

    debug && console.log(debug, 'render', value, field, props.model)

    return (

        <Popover
            position                = {PopoverPosition.bottomCenter()}
            popoverClass            = "task-select"
            getTargetFunc           = {()=>findDOMNode(props.parent)}
            onClickOutside          = {onClickOutside}
        >

            <div className="gd-entity-selector w-550 h-400">
                <FieldSelectTask_Popover_Selector
                     onEntitySelected    = {onClickTask}
                />
            </div>

        </Popover>

    )
}
